import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GridComponent } from './grid.component';
import { NzTableModule } from 'ng-zorro-antd/table';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzDividerModule } from 'ng-zorro-antd/divider';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzTagModule } from 'ng-zorro-antd/tag';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { NzPopconfirmModule } from 'ng-zorro-antd/popconfirm';
import { NzBadgeModule } from 'ng-zorro-antd/badge';

import { NzDatePickerModule } from 'ng-zorro-antd/date-picker';
import { ReactiveFormsModule } from '@angular/forms';
import { InvokePipe } from './invoke.pipe';
import { RouterModule } from '@angular/router';
import { LookupComponent } from '../lookup/lookup.component';
import { NzPopoverModule } from 'ng-zorro-antd/popover';

@NgModule({
  declarations: [GridComponent, InvokePipe],
  imports: [
    CommonModule,
    NzTableModule,
    NzIconModule,
    ReactiveFormsModule,
    NzDividerModule,
    NzButtonModule,
    RouterModule,
    NzTagModule,
    NzToolTipModule,
    NzInputModule,
    LookupComponent,
    NzDatePickerModule,
    NzSelectModule,
    NzPopconfirmModule,
    NzBadgeModule,
    NzPopoverModule
  ],
  exports: [GridComponent]
})
export class GridModule {}
